<div id="delegation-add">
  <p class="TXT_TITLE">:: {{ constants.newDelegation }} ::</p>
  <div style="margin: 20px 0px 10px">
    <p class="TXT_TITLE">{{ constants.delegationPeriodDesc }} -</p>
  </div>

  <form [formGroup]="delegationForm" (ngSubmit)="onSubmit()">
    <div nz-row class="form-group">
      <div nz-col nzSpan="2">
        <label for="delDateFrom">
          <span class="required asterisk">*</span>{{ constants.from }}:
        </label>
      </div>
      <div nz-col nzSpan="6">
        <nz-date-picker
          formControlName="delDateFrom"
          [nzPlaceHolder]="'Select From Date'"
        ></nz-date-picker>
      </div>
    </div>

    <div nz-row class="form-group">
      <div nz-col nzSpan="2">
        <label for="delDateThrough">
          <span class="required asterisk">*</span>{{ constants.through }}:
        </label>
      </div>
      <div nz-col nzSpan="6">
        <nz-date-picker
          formControlName="delDateThrough"
          [nzPlaceHolder]="'Start Through Date'"
        ></nz-date-picker>
      </div>
    </div>

    <div nz-row class="form-group">
      <div nz-col nzSpan="2">
        <label for="delThrough">
          <span class="required asterisk">*</span>{{ constants.delegateTo }}:
        </label>
      </div>
      <div nz-col nzSpan="6">
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Delegate"
          formControlName="delThrough"
        >
          <nz-option
            *ngFor="let user of delegateOptions"
            nzLabel="{{ user.name }}"
            nzValue="{{ user.email }}"
          ></nz-option>
        </nz-select>
      </div>
    </div>

    <button type="submit" nz-button nzType="primary" [disabled]="isSubmitted">
      {{ constants.save }}
    </button>
    <button
      type="button"
      nz-button
      nzType="default"
      (click)="backButton()"
      style="margin-left: 15px"
    >
      BACK
    </button>
  </form>

  <div
    *ngIf="isSubmitted && selectedDelegateeName"
    class="alert alert-success mt-3"
  >
    <strong>{{ constants.delegationAssignedTo }}:</strong>
    {{ selectedDelegateeName }}
  </div>
</div>
